<h2 mat-dialog-title>Tekening importeren</h2>
<mat-dialog-content>
    <div class="col-24 mb-3">
        <button (click)="uploadInput.click()" class="curpoint mr-2" color="accent" mat-stroked-button>
            Selecteer bestand
            <input #uploadInput (change)="uploadDrawing($event)" hidden type="file">
        </button>
        <br><br>
        <ng-select [formControl]="form.controls.customer_id"
                   appearance="fill"
                   [virtualScroll]="true"
                   [clearable]="false"
                   bindLabel="name"
                   bindValue="id"
                   placeholder="Kies een klant">
            <ng-option *ngFor="let customer of customers" [value]="customer.id">
                {{customer.name}}
            </ng-option>
        </ng-select>
        <mat-error [control]="form.controls.customer_id"></mat-error>

        <ng-select [formControl]="form.controls.project_id"
                   appearance="fill"
                   [virtualScroll]="true"
                   [clearable]="false"
                   bindLabel="name"
                   bindValue="id"
                   placeholder="Kies een opdracht">
            <ng-option *ngFor="let project of projects | filter : form.value.customer_id : 'customer_id'" [value]="project.id">
                {{project.name}}
            </ng-option>
        </ng-select>
        <mat-error [control]="form.controls.project_id"></mat-error>

        <form [formGroup]="form">
            <mat-form-field>
                <mat-label>Naam</mat-label>
                <input matInput [formControl]="form.controls.name">
                <mat-error [control]="form.controls.name"></mat-error>
            </mat-form-field>
        </form>

    </div>

    <div class="actions d-flex justify-content-between">
        <button mat-button type="button" (click)="onClose()">Sluiten</button>
        <button mat-raised-button color="primary" (click)="save()" type="submit" [disabled]="form.invalid">Importeren</button>
    </div>

</mat-dialog-content>
